import { constants } from '../utils';
import { getData } from './local-storage.service';

export enum DownloadType {
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
  DISCARDED = 'DISCARDED',
  VALID = 'VALID',
}

const downloadUrls: Record<DownloadType, (id: string) => string> = {
  [DownloadType.EXPORT]: (id) => `${constants.API_URL}/export/${id}/download`,
  [DownloadType.IMPORT]: (id) => `${constants.API_URL}/file/${id}/download`,
  [DownloadType.DISCARDED]: (id) => `${constants.API_URL}/import/${id}/discarded`,
  [DownloadType.VALID]: (id) => `${constants.API_URL}/import/${id}/valid`,
}

async function downloadCSV (downloadType: DownloadType, id: string): Promise<BlobPart> {
  const token = getData(constants.AUTH_USER_TOKEN_KEY);
  const fetchOpts: RequestInit = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let URL = downloadUrls[downloadType](id);
  const fetchResponse: Response = await fetch(URL, fetchOpts);
  const response: BlobPart = await fetchResponse.blob();
  return response;
}

export {
  downloadCSV,
}